<!-- 试题内容 -->
<template>
	<div class="testContentBox">
		<el-container class="el-container-box">
			<el-header>
				<p class="coilingTitle">试题内容</p>
				<div class="coilingBtn">
					<el-tooltip placement="top">
						<div v-if="isCollection" slot="content" icon="el-icon-star-off" class="elIconStar">
							已保存到收藏夹
							<p @click="sendValueToParent">
								去查看
								<img src="../../assets/images/icon-right.png" alt="" />
							</p>
						</div>
						<div v-else slot="content" icon="el-icon-star-off" class="elIconStar">
							收藏后可查看
						</div>
						<div class="tooltipIcon" @click="collectionHandle">
							<img src="../../assets/images/icon_collection_select.png" alt="" v-if="isCollection" />
							<img v-else src="../../assets/images/icon_collection.png" alt="" />
							<span style="color: #303133">收藏</span>
						</div>
					</el-tooltip>

					<div class="enable">
						启用：
						<el-switch v-model="enable" @change="enableChange" active-color="#0BAE6A"></el-switch>
					</div>

					<el-button plain @click="showCoilingDialog" size="small"
						class="btnAddress btnAddressPlain">
						<img src="../../assets/images/icon-fraction.png" alt="" />
						题目赋分
					</el-button>
					<!-- <el-button @click="createField" size="small" class="btnAddress btnAddressF btnAddressCreate">
						<img src="../../assets/images/icon-create.png" alt="" />
						创建栏位
					</el-button> -->
					<el-dropdown class="progress_create" @command="dropCommand">
						<el-button size="small" plain class="btnAddress btnAddressF btnAddressCreate">
							<div>
								<img src="../../assets/images/icon-create.png" />
								<p>创建栏位</p>
							</div>
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="1">新建栏位</el-dropdown-item>
							<el-dropdown-item command="2">收藏栏位</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<el-dropdown style="margin-left: 10rem" @command="fileImport" slot="dropdown">
						<el-button class="btnAddress btnAddressF" size="small">
							<img src="../../assets/images/icon-Import.png" alt="" />
							导入文件
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="add" style="width: 67rem;font-size:14rem">新增导入</el-dropdown-item>
							<el-dropdown-item command="cover" style="font-size:14rem">覆盖导入</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</el-header>
			<el-container>
				<!-- <el-aside class="elTreeBox" v-if="!isTreeShow"> -->
				<el-aside class="elTreeBox" v-if="moduleLevel">
					<p>题目编号</p>
					<vue-scroll class="scrollContentHappy" :ops="ops">
						<el-tree :data="questionNumber" node-key="id" default-expand-all :expand-on-click-node="false"
							@node-click="handleNodeClick">
						</el-tree>
					</vue-scroll>
				</el-aside>

				<el-main>
					<vue-scroll class="scrollContent" :ops="ops" ref="vueScrollBox" @handle-scroll="scrollChange">
						<AddFields ref="addFields" :isOperate.sync="isOperate" :enable.sync="enable"
							@fieldsArrChange="fieldsArrChange" @collectionAdd="collectionAdd" />
					</vue-scroll>
				</el-main>
			</el-container>
		</el-container>

		<!-- 题目赋分弹框 -->
		<!-- <keep-alive> -->
		<GiveFraction :centerDialogVisible.sync="centerDialogVisible" :questionNumber="questionNumber" :recoveryCoiling="recoveryCoiling" />
	</div>
</template>

<script>
import AddFields from "./addFields/AddFields";
// import { questionNumber } from "../../constants/constants";
import {
	EventBus
} from "@/utils/event-bus";
import {
	changeCoilingStatus,
	addStar,
	deleteStar,
	getCollectionStatus
} from "@/api/addModule";
import {
	isAddressType
} from "@/constants/constants";
import GiveFraction from "./dialog/giveFraction";
import {
	mapState,
	mapMutations
} from "vuex";

import vueScroll from "vuescroll";
import _ from 'lodash';
import { getModuleType } from "@/utils/util.js";

const TAG = "[TestContent.vue]";

export default {
	props: {
		message: {
			type: Array,
			// default: '' // 如果父组件没有传递值，这里可以设置一个默认值  
		},
		formData: {
			type: Object,
		},
		collectionTestAllId: {
			type: Number,
			default: 0
		},
        from: {
            type: String,
        },
	},
	name: "TestContent",
	components: {
		AddFields,
		vueScroll,
		GiveFraction,
	},
	watch: {
		// 总启用开关变化-详情启用开关全部变化
		totalEnable(newValue) {
			console.log("totalEnable", newValue);
			if (newValue == true || newValue == false) {
				this.enable = newValue;
			}
		},

		questionNumber: {
			handler(newVal) {
				console.log('questionNumberchanged===>');
				EventBus.$emit("getQuestionNumber", newVal);
			},
			deep: true,
		},
		message(newv) {
			console.log("zishoudao", this.message, newv);
			this.message.forEach((e) => {
				console.log("zishoudao", e);
				this.$refs.addFields.createField();
			})
		}
	},
	data() {
		return {
			// 滚动条的配置信息
			ops: {
				vueScroll: {},
				scrollPanel: {
					speed: 300,
				},
				rail: {
					opacity: "0.1",
					border: "1rem solid #f2f2f2",
					size: "3rem",
				},
				bar: {
					size: "4rem",
					background: "#D9D9D9",
					keepShow: true,
				},
			},
			isOperate: false,
			// questionNumber: JSON.parse(JSON.stringify(questionNumber)),
			questionNumber: [],
			questionNumberCopy: [],
			centerDialogVisible: false,

			isCollection: false,
			enable: false,
			coilingId: -1, // 套卷id
			// isTreeShow: true, // 题目编号在满足北京，题型专项训练下不显示
			inputBox: undefined,
			fileImportType: "add", // 新增导入add/覆盖导入cover
			nowId: 0,
			collectionId: this.collectionTestAllId,
			moduleLevel: 0
		};
	},

	methods: {
		//显示赋分弹框
		showCoilingDialog() {
			this.questionNumberCopy = _.cloneDeep(this.questionNumber);
			this.centerDialogVisible = true;
		},
		recoveryCoiling() {
			this.questionNumber = _.cloneDeep(this.questionNumberCopy);
		},
		//显示收藏夹
		sendValueToParent() {
			this.$emit("child-value", true);
		},
		...mapMutations(["coilingIdChange", "isTreeShowChange"]),

		// 导入文件
		fileImport(type) {
			if (this.coilingId == -1) {
				this.$message.error("请先新增套卷！");
				return;
			}
			this.inputBox.value = '';
			console.log(type);
			// 判断是否是"北京"  "题型专项训练"拦截
			if (isAddressType.isAddressType) {
				this.$message.error("请先选择类型");
				return;
			}

			if (type == "add") {
				this.fileImportType = "add";

				// 新增导入
				this.inputBox.click();
			} else {
				// 覆盖导入
				this.$confirm("覆盖导入后，新内容将覆盖已有内容", "是否覆盖导入？", {
					distinguishCancelAndClose: true,
					confirmButtonText: "覆盖",
					cancelButtonText: "取消",
					customClass: "customClass",
					confirmButtonClass: "btnConfirm",
					cancelButtonClass: "btnCancel",
				})
					.then(() => {
						this.fileImportType = "cover";

						this.inputBox.click();
					})
					.catch(() => { });
			}
		},
		scjShow(data) {
			this.$emit('scjShow', data);
		},
		operateInsertCollection(direction, id, fields) {
			console.log('testContent开始调用operateInsertCollection')
			this.$refs.addFields.operateInsertCollection(direction, id, fields)
		},
		collectionAdd(fieldStr) {
			addStar({
				coilingId: this.coilingId,
				area: this.formData.address,
				type: this.$route.query.type,
				source: this.formData.source,
				year: this.formData.year,
				collectionType: "test_single",
				content: fieldStr,
				pid: 0
			})
				.then((res) => {
					console.log(res);
					if (res["code"] == 0) {
						//this.nowId = res["data"];
						console.log('id===', res["data"]);
						this.$message.success("收藏成功！");
					} else {
						this.$message.error("收藏失败！");
						return;
					}
				})
				.catch((err) => {
					console.log("addStar err", err);
				});
		},
		// 点击收藏
		collectionHandle() {
			if (this.coilingId == -1) {
				this.$message.error("请先选择套卷！");
				return;
			}
			//console.log('fieldsJSON==', JSON.stringify(this.$store.state.fieldsJSON));
            //return;
			// 判断是否是"北京"  "题型专项训练"拦截
			// if (isAddressType.isAddressType) {
			//   this.$message.error("请先选择类型");
			//   return;
			// } else {
			//新增收藏，数据暂时，后期改为需要数据
			//this.nowId = this.collectionTestAllId
			//this.isCollection = this.nowId > 0
      let type= this.formData.type
      if(Array.isArray(type)){
        type= type.join(',')
      }
			if (!this.isCollection) {
				addStar({
					coilingId: this.$store.state.coilingId,
					area: this.formData.address,
					type,
					source: this.formData.source,
					year: this.formData.year,
					collectionType: "test_all",
					content: JSON.stringify(this.$store.state.fieldsJSON),
					pid: 0
				})
					.then((res) => {
						console.log(res);
						if (res["code"] == 0) {
							this.collectionId = res["data"];
							console.log('id===', this.collectionId);
							this.$message.success("收藏成功！");
						} else {
							this.$message.error("收藏失败！");
							return;
						}
					})
					.catch((err) => {
						console.log("addStar err", err);
					});
			} else {
				deleteStar(this.collectionId).then((res) => {
					if (res["code"] == 0) {
						this.$message({
							message: "取消收藏成功",
							type: "success",
						});
						this.collectionId = 0
					} else {
						this.$message.error("取消收藏失败");
						return;
					}
				});
			}

			// }

			this.isCollection = !this.isCollection;
		},

		// 树节点被点击
		handleNodeClick(data) {
			console.log("树节点被点击", data);
			let divId = data["divId"];

			let dotDivId = document.getElementById(divId);

			console.log(
				"divId",
				dotDivId.offsetTop,
				dotDivId.scrollTop,
				dotDivId.clientHeight
			);

			this.$refs.vueScrollBox.scrollTo({
				y: dotDivId.offsetTop
			}, 150);
		},

		// 栏位列表变化
		fieldsArrChange(arr) {
			console.log("栏位列表变化", arr);
			let time = parseInt(new Date().getTime()) + "";
			let questionNumberCopy = [];
			this.questionNumber = [];

			const pushObj = (i, defaultText) => {
				let pushObjDefault = {
					id: time,
					divId: arr[i]["id"],
					label: arr[i]["que_num"] ? arr[i]["que_num"] : defaultText,
					name: arr[i]["type"],
				};

				let isScore = Object.prototype.hasOwnProperty.call(arr[i], "score");
				let isTime = Object.prototype.hasOwnProperty.call(arr[i], "time");
				let ispyramid = Object.prototype.hasOwnProperty.call(arr[i], "pyramid");
				pushObjDefault.score = isScore ? arr[i]["score"] : "";
				pushObjDefault.time = isTime ? arr[i]["time"] : "";
				pushObjDefault.pyramid = ispyramid ? arr[i]["pyramid"] : "";

				return pushObjDefault;
			};

			let lev2Count = 1;

			for (let i = 0; i < arr.length; i++) {
				time++;
				if (arr[i]["type"] == "一级题干") {
					questionNumberCopy.push(pushObj(i, "一"));
					lev2Count = 1;
				} else if (arr[i]["type"] == "二级题干") {
					if (!questionNumberCopy.length) {
						continue;
					}

					let questionOne = questionNumberCopy[questionNumberCopy.length - 1];
					if (!("children" in questionOne)) {
						questionOne.children = [];
					}
					questionOne.children.push(pushObj(i, this.intToRoman(lev2Count)));
					lev2Count++;
				} else if (arr[i]["type"] == "题目") {
					if (questionNumberCopy.length) {
						let questionLast =
							questionNumberCopy[questionNumberCopy.length - 1];

						if ("children" in questionLast) {
							if (questionLast.children.length) {
								let questionLastLast =
									questionLast.children[questionLast.children.length - 1];

								if (questionLastLast.name == "题目") {
									questionLast.children.push(pushObj(i, "1"));
								} else {
									if ("children" in questionLastLast) {
										questionLastLast.children.push(pushObj(i, "1"));
									} else {
										questionLastLast.children = [pushObj(i, "1")];
									}
								}
							} else {
								questionLast.children.push(pushObj(i, "1"));
							}
						} else {
							questionLast.children = [pushObj(i, "1")];
						}
					} else {
						questionNumberCopy.push(pushObj(i, "1"));
					}
				} else {
					console.log(123);
				}
			}

			console.log("questionNumberCopy", questionNumberCopy);
			this.questionNumber = questionNumberCopy;
		},

		intToRoman(num) {
			let result = "";

			while (num > 0) {
				switch (true) {
					case (num >= 1000):
						result += 'M';
						num -= 1000;
						break;
					case (num >= 900):
						result += 'CM';
						num -= 900;
						break;
					case (num >= 500):
						result += 'D';
						num -= 500;
						break;
					case (num >= 400):
						result += 'CD';
						num -= 400;
						break;
					case (num >= 100):
						result += 'C';
						num -= 100;
						break;
					case (num >= 90):
						result += 'XC';
						num -= 90;
						break;
					case (num >= 50):
						result += 'L';
						num -= 50;
						break;
					case (num >= 40):
						result += 'XL';
						num -= 40;
						break;
					case (num >= 10):
						result += 'X';
						num -= 10;
						break;
					case (num >= 9):
						result += 'IX';
						num -= 9;
						break;
					case (num >= 5):
						result += 'V';
						num -= 5;
						break;
					case (num >= 4):
						result += 'IV';
						num -= 4;
						break;
					case (num >= 1):
						result += 'I';
						num -= 1;
						break;
				}
			}

			return result;
		},

		// 监听滚动事件
		scrollChange() {
			console.log(123);
			if (this.isOperate) {
				this.isOperate = false;
			}

			// console.log(event.target.scrollTop); // 输出滚动位置
		},

		dropCommand(command) {
			if (command === "1") {
				this.createField();
			}
			if (command === "2") {
				//EventBus.$emit("addFieldFromCollect");
                EventBus.$emit('scjShow',{
                            n1: true,
                            n2: false,
                            nowId: 0,
                            direction: false,
                            from: "content"
                        });
			}
		},

		// 点击创建栏位
		createField() {
            console.log(JSON.stringify(this.formData))
			console.log(this.from, this.coilingId)
			// return;
			// 判断是否是"北京"  "题型专项训练"拦截
			if (isAddressType.isAddressType  && !this.from) {
				this.$message.error("请先选择类型");
				return;
			}
            // if(this.from && !this.coilingId) {
			if(this.coilingId==-1) {
                this.$message.error("请先创建试卷！");
                return;
            }
			this.$refs.addFields.createField();
		},

		// 启用切换
		enableChange(e) {
			console.log(TAG + "deliveryChange", e);
			this.enable = !e;

			// 判断是否是"北京"  "题型专项训练"拦截
			if (isAddressType.isAddressType) {
				this.$message.error("请先选择类型");
				return;
			}

			let content_1 = !e ?
				"禁用后，将关闭该单元启用权限" :
				"启用后，将打开该单元启用权限";
			let content_2 = !e ? "是否禁用当前单元？" : "是否启用当前单元？";
			let confirm_text = !e ? "禁用" : "启用";

			this.$confirm(content_1, content_2, {
				distinguishCancelAndClose: true,
				confirmButtonText: confirm_text,
				cancelButtonText: "取消",
				customClass: "customClass_3",
				confirmButtonClass: "btnConfirm",
				cancelButtonClass: "btnCancel",
			})
				.then(() => {
					this.enableChangeCopy(e);
				})
				.catch(() => { });
		},

		// 启用切换
		enableChangeCopy(e) {
			console.log(TAG, "enableChange", e);

			const errorFn = () => {
				let errorVal = e ? "启用开启失败!" : "启用关闭失败!";
				this.$message.error(errorVal);

				setTimeout(() => {
					this.enable = !e;
				}, 1000);
			};

			if (this.coilingId < 0) {
				errorFn();
				return;
			}

			let data = {
				id: this.coilingId,
				status: e ? 0 : 1,
			};

			// 接口-设置启用变化
			changeCoilingStatus(data)
				.then((res) => {
					console.log(TAG + "res1", res);
					if (res && res["code"] == 0) {
						console.log(TAG + "res", res);
						this.enable = e;

						EventBus.$emit("detailEnableChange");
						this.$message({
							message: e ? "启用成功!" : "禁用成功!",
							type: "success",
						});
					} else {
						errorFn();
					}
				})
				.catch((err) => {
					console.log(TAG + "err", err);
					errorFn();
				});
		},
		getCollectionStatus(coid) {
            // let key = coid + "";
            // let content = sessionStorage.getItem(key);
                let data = {
                    collectionType: "test_all",
                    area: this.$route.query.region,
                    year: this.$route.query.year,
                    source: this.$route.query.questionSource,
                    content: JSON.stringify(this.$store.state.fieldsJSON),//this.$store.state.testContent,//content,
                    coilingId: coid
                };
			console.log('getCollectionStatus_data====+', data, this.$store.state);
			getCollectionStatus(data)
				.then((res) => {
					this.collectionId = res["data"];
					this.isCollection = this.collectionId > 0
					console.log('this.collectionTestAllI===', this.collectionTestAllId,this.collectionId,res)
				})
				.catch((err) => {
					console.log("getList err", err);
				});
		},
		// 新增套卷-清空列表 ,重新加载内容
		emptyFieldsArr(id) {
			this.getCollectionStatus(id);
			console.log(TAG, "emptyFieldsArr", id);
			this.coilingId = id;

			this.coilingIdChange(id);
		},
		// 创建收藏夹的栏位，包含试题内筒和答题流程
		createCollectionField(type, json) {
			if (type == "content") {
				console.log(json);
			} else if (type == "progress") {
				console.log(json);
			}
			// 获取接口id
			// let time = parseInt(new Date().getTime() / 1000) + "";
			/* if (this.coilingId == -1) {
					this.$message.error("请先新增套卷！");
					return;
				  }
				
				  this.time++;
				  let fieldsBasisCopy = { ...fieldsBasis };
				  fieldsBasisCopy.id = this.time + "";
				
				  this.fieldsArr.push(fieldsBasisCopy);
				
				  // 这里处理对象变化的逻辑
				  fieldsArrExternal = this.fieldsArr;
				  this.$emit("fieldsArrChange", this.fieldsArr); */
		},
		updateModuleStatus(){
			let moduleName = sessionStorage.getItem("editModuleName");console.log(moduleName)
			this.moduleLevel = getModuleType(moduleName,this)==1?true:false
			console.log(this.moduleLevel)
		}
	},
	beforeCreate() {

	},
	created() {

	},
	mounted() {
		this.moduleLevel = getModuleType(this.$route.query.type,this)==1?true:false

		console.log('试卷初始化页面coilingId', this.coilingId)
		//this.isCollection = this.collectionTestAllId > 0
		//this.nowId = this.collectionTestAllId
		console.log('collectionTestAllId===', this.collectionTestAllId)
		console.log('collectionId===', this.collectionId)
		this.isCollection = this.collectionId > 0;
		this.inputBox = document.createElement("input");
		// 设置input类型为file，表示文件选择器
		this.inputBox.type = "file";
		// 添加change事件监听器，当用户选择文件后触发
		this.inputBox.addEventListener("change", (event) => {
			// 获取选择的文件
			let selectedFile = event.target.files[0];

			// 在这里你可以处理选择的文件，比如读取内容或上传到服务器等
			console.log("选择的文件:", this.fileImportType, selectedFile);

			EventBus.$emit("txtImportHandle", selectedFile, this.fileImportType);
		});

		// isTreeShow
		// let address = this.$route.query.region;
		let type = this.$route.query.type;

		// this.isTreeShow = type.includes("题型专项训练");
		this.isTreeShowChange(type.includes("题型专项训练"));

		// 删除没有内容的树节点
		let label = document.getElementsByClassName("el-tree-node__label");
		for (let i = 0; i < label.length; i++) {
			let labelText = label[i].innerHTML;
			if (!labelText) {
				console.log(label[i]);
				label[i].parentElement.remove();
			}
		}

		// 新增套卷
		EventBus.$on("addCoilingHandle", this.emptyFieldsArr);

		// 监听滚动事件
		// let scrollContent = document.getElementsByClassName("scrollContent")[0];
		// let scrollContainer = scrollContent.getElementsByClassName("__panel")[0];
		// scrollContainer.addEventListener("scroll", this.scrollChange);
		window.addEventListener("wheel", this.scrollChange);
        // 获取收藏状态
        EventBus.$on("getCollectionStatus", this.getCollectionStatus);
		EventBus.$on("updateModuleStatus", this.updateModuleStatus);
	},

	computed: {
		...mapState(["totalEnable", "isTreeShow"]),
	},

	// 销毁前
	beforeDestroy() {
		EventBus.$off("addCoilingHandle", this.emptyFieldsArr);
        EventBus.$off("getCollectionStatus", this.getCollectionStatus);
		window.removeEventListener("wheel", this.scrollChange);
		EventBus.$off("updateModuleStatus", this.updateModuleStatus);
		this.coilingIdChange(0);
	},
};
</script>

<style lang="scss" scoped>
$elHeader: 60rem;

.scrollContent {
	height: 100%;
}

.scroll-wrapper {
	height: 100%;
	/* 设置一个高度 */
	overflow: hidden;
}

.scrollContentHappy {
	padding: 0 10rem;
	box-sizing: border-box;

	:deep .el-tree__empty-text {
		width: 100%;
	}
}

.happyScrollBox {
	padding: 0 10rem;
	box-sizing: border-box;
}

.elTreeBox {

	:deep .el-tree-node__content:hover,
	:deep .el-upload-list__item:hover {
		// background-color: #d5fae0;
		// background-color: #77db96;
	}

	:deep .el-tree-node__content:hover {
		border: 1rem solid #0BAE6A;
	}

	:deep .happy-scroll-container {
		width: 100% !important;
		padding-bottom: 20rem;
	}

	:deep .el-tree-node__content {
		// border: 3rem solid #fff;
		border: 1rem solid rgba(0, 0, 0, 0);
		padding-left: 10rem;
		margin-bottom: 4rem;
		// background-color: #f2fff6;
		background-color: #B6F9C9;
		border-radius: 3rem;
	}

	:deep .el-tree-node__content>.el-tree-node__expand-icon {
		margin-left: 6rem;
	}

	:deep .el-tree-node__label {
		font-size: 12rem;
	}

	:deep .el-tree-node:focus>.el-tree-node__content {
		background-color: #B6F9C9;
		border: 1rem solid #0BAE6A;
	}

	:deep .el-tree-node__expand-icon {
		color: #606266;
		cursor: pointer;
		&.is-leaf{
			color: transparent;
		}
	}

	:deep .el-tree {
		width: calc(100% - 12rem);
	}
}

.testContentBox {
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	padding: 20rem;
	border-radius: 12rem;
	background: #f5f5f5;

	.el-container-box {
		height: 100%;
		box-sizing: border-box;
		padding-top: 56rem;
		position: relative;
	}

	.el-container {
		height: 100%;
		box-sizing: border-box;
	}

	.el-header {
		padding: 0;
		height: 36rem !important;
		position: absolute;
		top: 0;
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}

	.el-aside {
		background: #fff;
		padding-top: 37rem;
		position: relative;
		overflow: hidden;
		width: 144rem !important;
		border-radius: 6rem;
		padding-bottom: 15rem;
		padding-right: 5rem;
		padding-left: 17rem;
		border: 1rem dashed #b1b1b1;
		margin-right: 20rem;

		>p {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 37rem;
			font-size: 12rem;
			color: #303133;
			text-align: center;
			line-height: 36rem;
			font-weight: 600;
		}
	}

	.el-main {
		overflow: inherit;
		background-color: #fff;
		border-radius: 6rem;
		padding: 19rem 5rem 12rem 0;
	}

	.coilingBtn {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
}

.coilingTable {
	height: 200rem;
	width: 100%;
	// overflow-x: scroll;
}

.coilingBox {
	display: flex;
	flex-direction: row;
}

.coilingChildList {
	display: flex;
	flex-direction: row;
}

.coilingChild {
	text-align: center;
	box-sizing: border-box;
}

.coilingChild2 {
	min-width: 50rem;
}

.coilingChild3 {
	width: 50rem;
	// background: #ccc;
	// margin: 1rem;
}

.coilingInside {
	height: 32rem;
	display: flex;
	justify-content: center;
	align-items: center;

	>div {
		width: 100%;
		height: 100%;
		background: #d5fae0;
		border-radius: 6rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14rem;
		color: #303133;
	}

	padding: 5rem;
}

.testContentBox {
	:deep .el-icon-star-on {
		color: #fcca00;
	}

	.tooltipIcon {
		cursor: pointer;
		font-size: 14rem;
		font-weight: 600;
		display: flex;
		align-items: center;

		img {
			margin-right: 2rem;
			width: 16rem;
			height: 16rem;
		}
	}
}

.elIconStar {
	font-size: 12rem;

	p {
		color: #ffb802;
		display: inline-block;
		cursor: pointer;

		img {
			width: 6rem;
			height: 11rem;
			position: relative;
			top: 1rem;
		}
	}
}

.enable {
	font-size: 14rem;
	color: #303133;
	margin: 0 16rem 0 20rem;
}

.btnAddressF {
	color: #fff;
}

.btnAddressCreate {
	background-image: linear-gradient(to right, #0078e7, #0295ff);
}

.progress_create {
	width: 110rem;
	height: 32rem;
	margin: 0 -10rem 0 10rem;

	.el-button {
		border-radius: 6rem;
		height: 100%;
		width: 100rem;
		border: none;
		background-image: linear-gradient(to right, #0078e7, #0295ff);
		color: #ffffff;
		font-size: 14rem;

		div {
			display: flex;
			justify-content: center;
			height: 100%;

			img {
				margin-right: 5rem;
			}
		}
	}
}


.btnAddressPlain {
	background-image: none !important;
	color: #0bae6a;
	border-radius: 6rem;
	border-color: #0bae6a !important;
}

.btnAddressPlain:hover {
	color: #0bae6a;
}

:deep .el-dropdown-menu__item:hover {
	background: #d5fae0;
	color: #0bae6a;
}

.elDialog {
	:deep .el-dialog__body {
		padding: 0 30rem;
	}

	::v-deep .el-dialog {
		border-radius: 10rem;
		height: 367rem;
		background: #f5f5f5;
	}

	:deep .el-tabs__item {
		padding: 6rem 16rem !important;
		height: auto;
		line-height: normal;
		color: #303133;
		background: #ecdcdc;
		border-radius: 6rem;
		margin-right: 10rem;
	}

	:deep .el-tabs__item.is-active {
		color: #fff;
		background: linear-gradient(to right, #09b17e, #08c162);
	}

	::v-deep .el-dialog__title {
		padding-left: 26rem;

		&:before {
			content: "";
			position: absolute;
			left: 30rem;
			top: 22rem;
			width: 5rem;
			height: 20rem;
			border-radius: 10rem;
			background-color: var(--primary-color);
		}
	}

	.coilingTable {
		background: #fff;
		border-radius: 8rem;
		height: 310rem;
		display: flex;
		flex-direction: row;

		.promptGive {
			width: 112rem;
			height: 310rem;
			padding-top: 132rem;

			>P {
				text-align: center;
				font-size: 12rem;
				color: #000;
				margin-bottom: 17rem;
			}
		}
	}
}
</style>
<style lang="scss">
.customClass_3 {
	width: 460rem;
	border-radius: 8rem;
	box-sizing: border-box;

	.el-message-box__header .el-message-box__title span {
		margin-left: 20rem;

		&::before {
			content: url(@/views/question/static/warning.png);

			position: relative;
			top: 5rem;
			left: -15rem;
		}
	}

	.el-message-box__headerbtn .el-message-box__close {
		// color: #ff0000;
		transform: scale(1.4, 1.4);
		margin-top: 10rem;
	}

	.el-message-box__title {
		font-size: 18rem;
		color: #000000;
		font-weight: bold;
		height: 30rem;

		span {
			position: absolute;
			top: 12rem;
		}
	}

	.el-message-box__content {
		font-size: 14rem;
		height: 24rem;

		p {
			margin-left: 48rem;
			position: absolute;
			top: -5rem;
		}
	}
}
</style>